import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import ReportsDetailsViewPage from './reports-details-page/ReportsDetailsViewPage'
import {ReportsListWrapper} from './reports-list/ReportsList'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Reports Management',
    path: '/apps/reports-management/reports',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ReportsRoutes = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='reports'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Reports List</PageTitle>
              <ReportsListWrapper />
            </>
          }
        />
        <Route path='reports/details-page/*' element={<ReportsDetailsViewPage />} />

        {/* <Route path='users/new' element={<NewSubAdminPage />} /> */}
      </Route>
      <Route index element={<Navigate to='/apps/reports-management/reports' />} />
    </Routes>
  )
}

export default ReportsRoutes
